import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';

import './dialog.css';

class Dialog extends PureComponent {
  render() {
    const { open, onClose } = this.props;

    return (
      <div className="dialog-container">
        <Modal show={open} onHide={onClose}>
          <i className="dialog-close" onClick={onClose}/>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

Dialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/widgets/Dialog/index.js